import styled from 'styled-components'

export const InputCreate = styled.input` 
  cursor: pointer;
  margin: 5px;
  background-color: #00000022;
  border-radius: 6px;
  &:focus{
    outline: none;
  }
`
